import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import useWindowHeight from "./hook/useWindowScreen";

function App() {
	const height = useWindowHeight();
	const mainHeight = height - 80 - 60; // Adjust for navbar height

	return (
		<BrowserRouter>
			<div className="flex flex-col h-screen">
				<Navbar />
				<main style={{ height: `${mainHeight}px` }} className="">
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/about" element={<About />} />
						<Route path="/services" element={<Services />} />
						<Route path="/contact" element={<Contact />} />
						<Route
							path="*"
							element={
								<div className="text-center text-white text-3xl mt-10">
									404 Not Found
								</div>
							}
						/>
					</Routes>
				</main>
				<Footer />
			</div>
		</BrowserRouter>
	);
}

export default App;
